<template>
    <div>
        <CRow class="list">
            <slot />
        </CRow>
    </div>
</template>

<script>
    import { ContainerMixin } from "vue-slicksort";
    export default {
        name: "sortableList",
        mixins: [ContainerMixin]
    };
</script>
